// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginMenu_loginContainer__q81KW","openLogin":"LoginMenu_openLogin__dzQzW","img":"LoginMenu_img__c-deo","pageLoad":"LoginMenu_pageLoad__7QdbF"};